import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { useLocation } from "react-router-dom";
import Badge from "react-bootstrap/Badge";
import moment from "moment";
import { isMobile, MobileView, BrowserView } from "react-device-detect";
import jwt_decode from "jwt-decode";
import { formatDate, formatDateForCreatedDate, formatDateForView, getUserDetails } from "../../utils/helper";

import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import InfoPill from "../InfoPill";
import Main from "../layout/Main";
import { Helmet } from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import * as constants from "../../constants/CONSTANT";
import { ROUTES } from "../../constants/webRouting";
import PERMISSIONS from "../../constants/permissions";

const LeadList = () => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [leadname, setProjectName] = useState();
  // const[contact,setContact] = useState(location.state ? location.state : {});
  const [lead, setProject] = useState();
  // const [userInfo, setUserInfo] = useState({});
  //////console.log('location.state ='+location.state)
  const [projectStatusArray, setProjectStatusArray] = useState(
    constants.Project_Stage_Status
  );

  async function init() {
    const products = await fuziElevatorsApi.fetchProducts();
    if (products) {
      setBody(products);
    } else {
      setBody([]);
      setProject([]);
    }
  }
  useEffect(() => {
    // setUserInfo(jwt_decode(localStorage.getItem("token")));
    // console.log("userInfo", userInfo);
    init();
    setProjectName(body.firstname + " " + body.lastname);
  }, [leadname]);

  const onFilterType = (event) => {
    if (event.target.value === "") {
      setBody(lead);
    } else {
      setBody(
        lead.filter((data) => {
          if (
            (data.projectstatus || "").toLowerCase() ===
            (event.target.value || "").toLowerCase()
          ) {
            return data;
          }
        })
      );
    }
  };

  const getStatusClass = (status) => {
    ////console.log('status',status)
    let accessStatusRec = projectStatusArray.filter((value, index, array) => {
      if (value.label === status) {
        return true;
      }
    });
    ////console.log('accessStatusRec',accessStatusRec)
    if (accessStatusRec && accessStatusRec.length > 0) {
      if (accessStatusRec[0].is_converted === true) {
        ////console.log('if isconverted')

        return "success";
      } else if (accessStatusRec[0].is_lost === true) {
        return "secondary";
      } else {
        return "primary";
      }
    } else {
      return "secondary";
    }
  };

  // Create table headers consisting of 4 columns.
  const header = [];

  if (!isMobile) {
    header.push(
      {
        title: "Product Name",
        prop: "product_name",
        isFilterable: true,
        isSortable: true,
        cell: (row) => (
          <Link to={`${ROUTES.PRODUCT.LIST}/${row.id}`} state={row}>
            {row.product_name}
          </Link>
        ),
      },

      {
        title: "Product Description",
        prop: "product_description",
        isFilterable: true,
      },
      {
        title: "External Source Name",
        prop: "external_source_name",
        isFilterable: true,
      },
      //formatDateForView added by shahir hussain 27-08-2025
      {
        title: "Created Date",
        prop: "createddate",
        isSortable: true,
        isFilterable: true,
        cell: (row) => (
          row?.createddate ? formatDateForView(row.createddate) : ''
        ),
      }
    );
  } else {
    //for mobile device

    header.push({
      title: "Info",
      prop: "product_name",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link
            to={`${ROUTES.PRODUCT.LIST}/${row.id}`}
            state={row}
            style={{ fontSize: "1.2rem" }}
          >
            {row.product_name}
          </Link>
          <span>
            <i class="fa-solid fa-phone"></i> {row.product_description}
          </span>
          <span style={{ width: "80%" }}>
            <i class="fa-solid fa-envelope"></i> {row.createddate}
          </span>
        </div>
      ),
    });
  }

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createProject = () => {
    navigate(`/products/e`);
  };

  return (
    <Container>
      <Row className="">
        <Col lg={12} className="">
          <DatatableWrapper
            body={body}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 50,
                options: [5, 10, 15, 20, 30, 50]
              },
            }}
          >
            <Row className="align-items-end">
              <Col>
                <Filter
                  classes={{
                    inputGroup: "",
                    input: "",
                    clearButton: "btn-custom",
                  }}
                />
              </Col>
              <Col>
                <PaginationOptions labels={labels} />
              </Col>
              <Col className="py-1">
                <BrowserView>
                  <div className="d-flex py-1 px-2 ">
                    <InfoPill
                      left="Total"
                      right={body?.length}
                      rightClasses="bg-custom text-white border-white fw-bold"
                      leftClasses="bg-white text-danger fw-bold "
                    />
                  </div>
                </BrowserView>
              </Col>

              <Col className="d-flex flex-col justify-content-end align-items-end">
                {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_PRODUCT].some(permission => {
                  return userInfo?.permissions.map(p => p.name).includes(permission);
                }) && (
                    <Button
                      size="sm"
                      className="btn-create"
                      onClick={() => createProject(true)}
                    >
                      New Product
                    </Button>
                  )}
              </Col>
            </Row>
            {/* <Table striped className="shadow rounded sm my-4" responsive={true}>
              <TableHeader classes={{ th: "bg-custom text-white" }} />
              {body && Array.isArray(body) ? (
                <TableBody />
              ) : (
                <tbody className="">
                  <tr>
                    <td colSpan={100} align="center">
                      <div>
                        <Spinner />
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            </Table> */}

            <div className="table-scroll my-3">
              <Table striped className="shadow rounded sm my-4">
                <TableHeader classes={{ th: 'bg-custom text-white sticky-header' }} />
                {
                  (body && Array.isArray(body)) ?
                    <TableBody />
                    :
                    <tbody className="">
                      <tr>
                        <td colSpan={100} align="center">
                          <div>
                            <Spinner />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                }
              </Table>
            </div>
            <Pagination
              classes={{
                buttonGroup: "btn-custom",
                button: "bg-custom border-white",
              }}
            />
          </DatatableWrapper>
        </Col>
      </Row>
    </Container>
  );
};
export default LeadList;
